module.exports = __webpack_public_path__ + "img/forest.be5030ca.webp";